import MainContent from './MainContent';

export { MainContent };
export default MainContent;
